import { useNavigate } from 'react-router-dom';
import PieChart from '../../components/pie-chart/PieChart';
import { WorksheetStatistics } from '../../types/worksheet';

type WorksheetsChartProps = {
    progress: WorksheetStatistics;
};

function WorksheetsChart({ progress }: WorksheetsChartProps): JSX.Element {
    const total = progress.inProgress + progress.unprepared + progress.awaitingReview + progress.reviewed + progress.excluded;
    const percentComplete = total === 0 ? 100 : Math.floor(((progress.reviewed + progress.excluded) / total) * 100);
    const navigate = useNavigate();

    const slices = [
        {
            legend: `${progress.reviewed} Reviewed`,
            color: percentComplete === 100 ? '#16a34a' : '#6366f1',
            count: progress.reviewed,
            percent: total === 0 ? 100 : Math.floor((progress.reviewed / total) * 100),
            title: 'Reviewed',
            href: '../trial-balance?tab=reviewed',
        },
        {
            legend: `${progress.excluded} Excluded`,
            color: percentComplete === 100 ? '#16a34a' : '#9ca3af',
            count: progress.excluded,
            percent: total === 0 ? 0 : Math.floor((progress.excluded / total) * 100),
            title: 'Excluded',
            href: '../trial-balance?tab=excluded',
        },
        {
            legend: `${progress.awaitingReview} Awaiting Review`,
            color: percentComplete === 100 ? '#16a34a' : '#3b82f6',
            count: progress.awaitingReview,
            percent: total === 0 ? 0 : Math.floor((progress.awaitingReview / total) * 100),
            title: 'Awaiting Review',
            href: '../trial-balance?tab=awaiting_review',
        },
        {
            legend: `${progress.inProgress} In Progress`,
            color: percentComplete === 100 ? '#16a34a' : '#eab308',
            count: progress.inProgress,
            percent: total === 0 ? 0 : Math.floor((progress.inProgress / total) * 100),
            title: 'In Progress',
            href: '../trial-balance?tab=in_progress',
        },
        {
            legend: `${progress.unprepared} Unprepared`,
            color: percentComplete === 100 ? '#16a34a' : '#e5e7eb',
            count: progress.unprepared,
            percent: total === 0 ? 0 : Math.floor((progress.unprepared / total) * 100),
            title: 'Unprepared',
            href: '../trial-balance?tab=unprepared',
        },
    ];

    return (
        <div className="rounded-md w-fit p-6">
            <PieChart title="Trial Balance" figure={Math.floor(percentComplete)} slices={slices} />
        </div>
    );
}

export default WorksheetsChart;
